export default __webpack_public_path__ + "static/media/logo-survey.44926963.png";